export default __webpack_public_path__ + "static/assets/97b539a9234a4dab6050db8cfe364d0e.png";